import { render, staticRenderFns } from "./PageEditorSectionTemplateMenu.vue?vue&type=template&id=7fc7ee5a&scoped=true"
import script from "./PageEditorSectionTemplateMenu.vue?vue&type=script&lang=js"
export * from "./PageEditorSectionTemplateMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc7ee5a",
  null
  
)

export default component.exports